module.exports = (theme) => ({
  ".list": {
    marginTop: theme("spacing.DEFAULT"),
    marginBottom: theme("spacing.DEFAULT"),
    paddingLeft: theme("spacing.DEFAULT"),
    paddingRight: "0",
    paddingTop: "0",
    paddingBottom: "0",
  },
  ".list li": {
    lineHeight: theme("lineHeight.base"),
    paddingTop: theme("spacing.sm"),
    paddingRight: "0",
    paddingBottom: theme("spacing.sm"),
    paddingLeft: theme("spacing.DEFAULT"),
  },

  "ul.list": {
    listStyle: "none",
  },

  "ol.list": {
    listStyle: "decimal",
  },

  ".list.narrow": {
    paddingLeft: theme("fontSize.xl"),
    marginTop: theme("spacing.DEFAULT"),
    marginBottom: theme("spacing.DEFAULT"),
  },

  ".list.narrow li": {
    padding: "0",
    paddingLeft: theme("spacing.sm"),
  },

  ".list.disc.narrow": {
    paddingLeft: "20px",
  },

  ".list.disc li::before": {
    backgroundColor: theme("colors.primary.black.DEFAULT"),
    borderRadius: "3px",
    display: "inline-block",
    marginRight: theme("spacing.sm"),
    padding: "3px",
    verticalAlign: "middle",
    content: '""',
    listStyle: "none",
    marginLeft: "-18px",
  },

  ".list.disc.blue li::before": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
  },

  ".list.check-mark.narrow": {
    paddingLeft: "20px",
  },

  ".list.check-mark li::before": {
    fontFamily: '"Vattenfall Elements Icons", "Vattenfall Icons"',
    content: '"\\e97f"',
    marginRight: theme("spacing.sm"),
    marginLeft: "-34px",
    fontSize: theme("fontSize.2xl"),
    verticalAlign: "bottom",
  },
});
